import React, { useEffect, useState } from "react";
import { PHONE_SCREEN_STICKY_BOTTOM_POSITION } from "../Util/dimensionConstants";

export default function HostPageADC({ position, phoneScreenBottom }) {
  const [opacity, setOpacity] = useState(1);
  const [stickyPosition, setStickyPosition] = useState(null);

  useEffect(() => {
    if (
      phoneScreenBottom <= PHONE_SCREEN_STICKY_BOTTOM_POSITION &&
      !stickyPosition
    ) {
      setStickyPosition(position);
    }
    if (stickyPosition) {
      setOpacity(1 - (position - stickyPosition) / window.innerHeight);
    }
  }, [position]);

  const animationStyle = ` @keyframes fadeAway {
        from { opacity: 1; }
        to { opacity: ${opacity}; }
      }
        .hostPageText {
          font-size: 20px;
          color: black;
          width: 20px;
          z-index: 10;
          opacity:${opacity}
    
        }
    
        .animateText{
          animation-name: fadeAway;
          animation-duration: 1s;
          animation-fill-mode: forwards;
          animation-iteration-count: 1;
    
        }
    
        .hostPageArrow {
          object-fit: contain;
          transform: rotate(290deg);
          z-index: 10;
          opacity:${opacity}
        }
      }`;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row-reverse",
        position: "absolute",
        right: "50%",
        top: PHONE_SCREEN_STICKY_BOTTOM_POSITION - 180,
        zIndex: 4,
        paddingRight: 30,
        // backgroundColor: "blue",
      }}
    >
      <style>{animationStyle}</style>
      <img
        style={{
          width: 100,
        }}
        src={require("../Assets/CurvedArrowIcons/right-drawn-arrow.webp")}
        className={"hostPageArrow"}
        alt="Arrow Indicating huming feature"
        title="This arrow indicates the entry point button which start your hosting process in which the photos and videos will be shared automatically"
        loading="lazy"
      />
      <p
        style={{
          marginRight: "50%",
        }}
        className={"hostPageText"}
      >
        Go Instant or Plan It
      </p>
    </div>
  );
}
